import React, { FC, ReactNode } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";

interface RatesQuoteButtonProps {
  children: ReactNode;
  onClick: () => void;
}

const RatesQuoteButton: FC<RatesQuoteButtonProps> = (props) => {
  const { children, onClick } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <button className={styles.root} onClick={onClick}>{children}</button>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      cursor: pointer;
      padding-left: 18px;
      padding-right: 18px;
      border: 1px solid #D3D5DC;
      border-radius: 6px;
      background-color: #F8F8F8;
      height: 44px;
      font-weight: 600;
      font-size: 16px;
      color: #181818;
      font-family: Mulish, sans-serif;
      ${theme.breakpoints.mobile.up} {
        margin-left: auto;
      }
    `,
  }
);

export default RatesQuoteButton;